import { ReservationRetrievalObject } from "../../../models";

export const olciDataDefault: ReservationRetrievalObject = {
    brand: '',
    lastName: '',
    bookingId: '',    
	departureYear: '', //TODO remove after middleware is depecrated
	departureMonth: '', //TODO remove after middleware is depecrated
	departureDay: '', //TODO remove after middleware is depecrated
    sailDate: '',
    shipCode: '',
    vdsId: '',
    guestId: '',
    charterSailing: false,
    locale: '',
    email: '',
    dob: '',
    accountOwnerName: '',
}